import i18n from "../../../../../constants/i18n";
import getAuditStore from "../../../../../stores/auditor-store/audit-store";
import getTBWStore from "../../../../../stores/developer-store/tbw-store";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import { TCorePage, TTBWExtraData } from "../../../../../Types";
import Et3Button from "../../../../../core/et3-button";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import { reduce } from "et3-type-guards";

const AuditActions = withLiteObserverAndTheme<{
  pageName: TCorePage;
  eventID: number;
  reportedId: number;
  reportedUUID: string;
  takenActionType: string;
}>((props) => {
  const {
    pageName,
    takenActionType,
    eventID,
    reportedId,
    reportedUUID,
    theme
  } = props;
  const { colors } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const userUUID = reduce(
    () => getUserAdvancedStore().userData.get(userID).userUUID,
    ""
  );
  const userUUIDForTBW: TTBWExtraData = {
    userUUID,
    userID,
    reportedUUID: "",
    reportedID: -1,
    reportID: -1,
    secondPartyID: -1
  };

  return pageName === "AUDITOR_AUDIT" ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="space-around"
      alignItems="center"
      withShadow={false}
      width={700}
      height={70}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        onClick={async () => {
          await getTBWStore().showActionTBWPopUp({
            type: "AUDIT_REASON",
            headerMessage: i18n.getWithExtraData(
              "SELECT_REASONS_OF_ACTION",
              "Minor or Major"
            ),
            actionName: "",
            fromPage: "AUDITOR_AUDIT",
            extraData: userUUIDForTBW,
            eventId: eventID,
            issueAudit: "minor"
          });
        }}
        isEnabled={true}
        size="MEDIUM"
        text="MINOR_ISSUE"
        type="WARN"
      />
      <Et3Button
        onClick={async () => {
          await getTBWStore().showActionTBWPopUp({
            type: "AUDIT_REASON",
            headerMessage: i18n.getWithExtraData(
              "SELECT_REASONS_OF_ACTION",
              "Minor or Major"
            ),
            actionName: "",
            fromPage: "AUDITOR_AUDIT",
            extraData: userUUIDForTBW,
            eventId: eventID,
            issueAudit: "major"
          });
        }}
        isEnabled={true}
        type="REJECT"
        size="MEDIUM"
        text="MAJOR_ISSUE"
      />
      <Et3Button
        onClick={async () => {
          getTBWStore().auditEventProof.set("no_issue");
          await getAuditStore().takeAuditAction({
            actionType: "no_issue",
            userID: reportedId,
            userUUID: reportedUUID,
            eventID,
            eventType: takenActionType,
            imageID: ""
          });
        }}
        isEnabled={true}
        type="APPROVE"
        size="MEDIUM"
        text="NO_ISSUE"
      />
    </ET3Div>
  ) : null;
});
export default AuditActions;
